import * as React from "react";

function SvgTheTradeDesk(props, ref) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="2.5em"
      height="2.5em"
      viewBox="0 0 38.000000 39.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,39.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M114 341 c-2 -2 -4 -15 -4 -28 0 -20 4 -23 28 -21 27 3 27 2 32 -67
4 -62 7 -70 25 -70 19 0 20 7 20 94 l0 94 -48 1 c-27 0 -51 -1 -53 -3z"
        />
        <path
          d="M240 296 c0 -14 11 -37 24 -51 34 -37 41 -76 20 -120 -18 -39 -65
-70 -95 -62 -15 4 -19 0 -19 -23 0 -28 2 -28 38 -23 55 9 87 28 113 70 45 72
19 182 -52 218 -28 15 -29 15 -29 -9z"
        />
        <path
          d="M94 262 c-37 -4 -54 -33 -54 -93 0 -49 19 -88 62 -124 l33 -28 3 27
c2 17 -5 37 -22 57 -33 39 -35 95 -5 133 25 31 24 32 -17 28z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgTheTradeDesk);
